import React, { useEffect } from "react";
import { withLocalize } from "react-localize-redux";
import Select from "react-select";

const LanguageToggle = ({ languages, activeLanguage, setActiveLanguage }) => {

  useEffect(() => {
    if (localStorage.getItem("ikos-language") === "fr") {
      setActiveLanguage("fr")
    } else if( localStorage.getItem("ikos-language") === "es") {
      setActiveLanguage("es")
    }else if( localStorage.getItem("ikos-language") === "de") {
      setActiveLanguage("de")
    } else if( localStorage.getItem("ikos-language") === "it") {
      setActiveLanguage("it")
    }else {
      setActiveLanguage("en")
      localStorage.setItem("ikos-language", "en")
    }
  }, [])

  const customStyles = {
    // container: (base, state) => ( 
    //   {
    //   ...base,
    //   width:80,
    // }
    // ),
    control: (provided) => {
      // none of react-select's styles are passed to <Control />
      return ({ 
        ...provided,
        borderStyle: "none",
        display: "flex",
        justifyContent: "center",
        width: 80
      })
    }
  }

  let LangOptions = []
  languages.map(lang => {
    let option = {
      value: lang.code,
      label: lang.code
    }
    return LangOptions.push(option)
  })

  const handelChangeLanguage = (lang) => {
    localStorage.setItem("ikos-language", lang.value)
    return setActiveLanguage(lang.value)
  }

  return (
    <Select
      value={LangOptions.filter(option => option.label === activeLanguage.code)}
      classNamePrefix={"react-select"}
      className={"languages-container"}
      styles={customStyles}
      isSearchable={false}
      onChange={(lang ) => handelChangeLanguage(lang)}
      options={LangOptions}
    />
  // <ul className="selector">
  //   {languages.map(lang => (
  //     <li key={lang.code}>
  //       <span onClick={() => setActiveLanguage(lang.code)}>
  //         {lang.name}
  //       </span>
  //     </li>
  //   ))}
  // </ul>
  )
};

export default withLocalize(LanguageToggle);
